var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"480px"}},[_c('h1',{staticStyle:{"padding":"20px"}},[_vm._v("Error: 404 - Page not found!")])])}]

export { render, staticRenderFns }